module.exports = __webpack_public_path__ + "img/LogoGreen.153d33a3.png";